import { AfterContentInit, Component, forwardRef, Input, TemplateRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Orientation } from '../../../constants/orientation.constants';
import { BaseFormControlComponent } from '../base-form-control.component';

/**
 * This is a toggle switch
 * @export
 * @class LsqSwitchComponent
 * @extends {BaseFormControlComponent}
 * @property {string} name Defines the ID and For attributes
 * @property {string} [label] Adds a label nex to the switch
 * @property {Orientation} [labelOrientation] Set the placement for the label
 */
@Component({
    selector: 'lsq-switch',
    template: `
        <div
            *ngIf="label || labelTemplateRef"
            [id]="uniqueContainerId"
            class="form-group lsq-switch-container"
            [ngClass]="[labelOrientation, containerClass]"
        >
            <label
                *ngIf="label && labelOrientation !== bottom"
                [ngClass]="labelClass"
                [for]="uniqueId"
                [innerHTML]="label"
            >
            </label>
            <label
                *ngIf="labelTemplateRef && labelOrientation !== bottom"
                [ngClass]="labelClass"
                [for]="uniqueId"
            >
                <ng-container *ngTemplateOutlet="labelTemplateRef"></ng-container>
            </label>
            <div class="lsq-switch" [ngClass]="{ disabled: disabled }">
                <label [for]="uniqueId">
                    <input
                        type="checkbox"
                        [id]="uniqueId"
                        [name]="name"
                        [ngModel]="model"
                        [disabled]="disabled"
                        (ngModelChange)="handleChange($event)"
                    />
                    <span><small></small></span>
                </label>
            </div>
            <label
                *ngIf="label && labelOrientation === bottom"
                [ngClass]="labelClass"
                [for]="uniqueId"
                [innerHTML]="label"
            >
            </label>
            <label
                *ngIf="labelTemplateRef && labelOrientation === bottom"
                [ngClass]="labelClass"
                [for]="uniqueId"
            >
                <ng-container *ngTemplateOutlet="labelTemplateRef"></ng-container>
            </label>
        </div>

        <div class="lsq-switch" *ngIf="!label && !labelTemplateRef" [class.disabled]="disabled">
            <label [for]="uniqueId">
                <input
                    type="checkbox"
                    [id]="uniqueId"
                    [name]="name"
                    [ngModel]="model"
                    [disabled]="disabled"
                    (ngModelChange)="handleChange($event)"
                />
                <span><small></small></span>
            </label>
        </div>
    `,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => LsqSwitchComponent),
            multi: true
        }
    ],
    styleUrls: ['./lsq-switch.component.scss']
})
export class LsqSwitchComponent extends BaseFormControlComponent<boolean>
    implements AfterContentInit {
    @Input() public containerClass? = '';
    @Input() public name: string;
    @Input() public label?: string;
    @Input() public labelTemplateRef?: TemplateRef<any>;
    @Input() public labelClass?: string;
    @Input() public labelOrientation? = '';
    @Input() public disabled = false;
    public top = Orientation.Top;
    public right = Orientation.Right;
    public bottom = Orientation.Bottom;
    public left = Orientation.Left;
    public uniqueContainerId: string;
    public uniqueId: string;

    public ngAfterContentInit() {
        this.uniqueContainerId = `${this.name}-container`;
        this.uniqueId = `${this.name}-switch-id`;
        this.model = this.model == null ? false : this.model;
        if ((this.label || this.labelTemplateRef) && !this.labelOrientation) {
            this.labelOrientation = this.left;
        }
    }
}
